import types from '@/vuex/documentos-favoritos/actions-types'
import documentos from '@/utils/documentos'

const actions = {
  [types.SET_LISTA_FAVORITOS]: ({ commit }, payload) => commit(types.SET_LISTA_FAVORITOS, payload),
  [types.BUSCAR_FAVORITOS]: async ({ commit }, payload) => {
    try {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Favoritos' }, {root: true})
      const response = await documentos.buscarDocumentosFavoritos(payload)
      const length = response.body.length
      for (let i = 0; i < length; i++) {
        response.body[i].tagsFavoritoTela = response.body[i].tagsFavorito ? response.body[i].tagsFavorito : []
        if (response.body[i].estado && response.body[i].estado['32002'] === 3) {
          response.body[i].tipo = response.body[i].tipo + ' (Digitalizado)'
        }
      }

      commit(types.SET_LISTA_FAVORITOS, { listaDeDocumentosFavoritos: response.body })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar os documentos favoritos' }, {root: true})
      throw error
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando Favoritos' }, {root: true})
    }
  },
  [types.DESFAVORITAR_DOCUMENTO]: async ({ commit, dispatch }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Removendo documento dos favoritos' }, {root: true})
    try {
      await documentos.desfavoritarDocumento(payload.idDocumento)

      payload.listaFavoritos.splice(payload.listaFavoritos.findIndex(function (i) {
        return i.idDocumento === payload.idDocumento
      }), 1)

      commit(types.SET_LISTA_FAVORITOS, { listaDeDocumentosFavoritos: payload.listaFavoritos })
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Documento removido dos favoritos com sucesso' }, {root: true})
      return true
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível remover o documento dos favoritos' }, {root: true})
      return false
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Removendo documento dos favoritos' }, {root: true})
    }
  },
  [types.ALTERNAR_ACOMPANHAMENTO]: async ({ commit, dispatch }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Alternando acompanhamento por email de documento favorito' }, {root: true})
    try {
      await documentos.alternarAcompanhamentoDeDocumentoFavorito(payload.idDocumento, payload.acompanharPorEmail)

      payload.listaFavoritos.forEach(function (i) {
        if (i.idDocumento === payload.idDocumento) {
          i.acompanhadoPorEmail = payload.acompanharPorEmail
        }
      })

      commit(types.SET_LISTA_FAVORITOS, { listaDeDocumentosFavoritos: payload.listaFavoritos })
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Opção de acompanhamento do documento favorito alternada com sucesso.' }, {root: true})
      return true
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível alternar a opção de acompanhamento por email do favorito' }, {root: true})
      return false
    } finally {
      commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Alternando acompanhamento por email de documento favorito' }, {root: true})
    }
  },

  [types.GET_ULTIMA_TRAMITACAO]: async ({ commit }, payload) => {
    if (payload.props.item.situacao !== 'EM_CRIACAO') {
      commit(types.SHOW_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando ultima tramitação' }, {root: true})
      try {
        const response = await documentos.getUltimaTramitacao(payload.props.item.idDocumento)
        payload.props.item.ultimaTramitacao = response.data
      } catch (error) {
        commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível carregar informações da última tramitação' }, {root: true})
        throw error
      } finally {
        commit(types.HIDE_GLOBAL_LOADING, { globalLoadingTitle: 'Buscando ultima tramitação' }, {root: true})
      }
    }
  },
  [types.ATUALIZA_MARCADORES]: async ({ commit }, payload) => {
    try {
      await documentos.alterarMarcadoresDeDocumentosFavoritos(payload.idDocumento, payload.tagsFavoritoTela)
      payload.tagsFavorito = payload.tagsFavoritoTela
      commit(types.SHOW_SNACKBAR, { snackbarType: 'success', snackbarText: 'Marcadores salvos.' }, {root: true})
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Erro ao salvar os marcadores.' }, {root: true})
      throw error
    }
  }
}

export default actions
